( function ( $ ) {
	$(document).foundation();

	var header_bar = (function() {

	  var page_top_value = 0;
	  var $header_wrapper = $('#header-wrapper');

		var setHeaderHeight = function() {
			var headerHeight = $('#header-wrapper').height();
			if ($('body').hasClass('admin-bar')) {
				page_top_value = $('#wpadminbar').outerHeight();
			} else {
				page_top_value = 0;
			}
			$('.primary-nav').css('padding-top', (headerHeight + page_top_value) + 'px');
			$('body').css('padding-top', headerHeight + 'px');
			console.log('setting height: ' + headerHeight);
		};

	  var hideHamburgerMenuDisplay = function() {
			$('#header-wrapper').removeClass('is-visible is-fixed');
			$('#header-wrapper').css('top', page_top_value + 'px');

			$('body').removeClass('overflow-hidden');
			$('.hamburger-menu-icon').removeClass('is-clicked');
			$('.primary-nav').removeClass('is-visible');
	  };

	  var registerHeaderScrollDisplayListener = function() {
			$(window).on('scroll',
				{
		        previousTop: 0
		    },
		    function () {
			    //if (!$('.primary-nav.is-visible').length) {
				    // $('.primary-nav.is-visible').length == 0 means the primary nav is visible.
				    // Enter this clause if the primary nav is not open. This check is needed since on mobile touch devices
				    // the menu can't be scrolled without triggering the menu to disappear

				    var currentTop = $(window).scrollTop();
				    var headerHeight = $header_wrapper.height();
				    //check if user is scrolling up
				    if (currentTop < this.previousTop ) {
				    	//if scrolling up...
				    	if (currentTop > 0 && $header_wrapper.hasClass('is-fixed')) {
				    		$header_wrapper.addClass('is-visible');
				    	} else {
				    		$header_wrapper.removeClass('is-visible is-fixed');
				    		$header_wrapper.css('top', page_top_value + 'px');
				    	}
				    } else {
				    	//if scrolling down...
				    	$header_wrapper.removeClass('is-visible');
				    	if( currentTop > headerHeight && !$header_wrapper.hasClass('is-fixed')) {

				    			$header_wrapper.addClass('is-fixed');
				    			$header_wrapper.css('top', '-' + (headerHeight - page_top_value) + 'px');

				    	}
				    }
				    this.previousTop = currentTop;
			    //}
			});
	  };

	  var registerHamburgerMenuDisplayListener = function() {
			// for accessibility, all links in primary nav are set to tabindex -1 so they can't be accessed with tab navigation
			$('.primary-nav a').attr('tabindex', '-1');

			$('#full-menu-toggle').on('click', function(e){
				e.preventDefault();
				$('.hamburger-menu-icon').toggleClass('is-clicked');
				//$('#header').toggleClass('menu-is-open');

				//in firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
				if( $('.primary-nav').hasClass('is-visible') ) {
					$('.primary-nav').removeClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
						$('body').removeClass('overflow-hidden');

						// when the primary nav is hidden again we set links to tabindex -1 so they can not be focused with tab navigation
						$('.primary-nav a').attr('tabindex', '-1');
						$('#full-menu-toggle').attr("aria-expanded", false);
					});
				} else {
					$('.primary-nav').addClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
						$('body').addClass('overflow-hidden');

						// once the primary nav is active, the links within can be focused with with tab controls
						$('.primary-nav a').removeAttr('tabindex');
						$('#full-menu-toggle').attr("aria-expanded", true);
					});
				}
			});
	  };


	  // Public API
	  return {
      setHeaderHeight: setHeaderHeight,
      hideHamburgerMenuDisplay: hideHamburgerMenuDisplay,
      registerHeaderScrollDisplayListener: registerHeaderScrollDisplayListener,
      registerHamburgerMenuDisplayListener: registerHamburgerMenuDisplayListener
	  };
	})();


	var photo_gallery = (function() {

	  var initialize = function() {
		  $('.photo-slider__container').slick({
		  	lazyLoad: 'ondemand',
			  dots: true,
			  infinite: true,
			  speed: 300,
			  slidesToShow: 1,
			  adaptiveHeight: true
			});

			$('body').addClass('gallery-initialized');
	  };

	  //set gallery item width
	  var setGalleryImageHeight = function(){
	  	var images = $('.slider-img');
	     $.each(images, function(i, img){
	       var ratio = $(img).attr("data-ratio");
	       $(img).css("height", $(img).parent().width()*ratio+"px");
	     });
	  }

	  // Public API
	  return {
	    initialize: initialize,
	    setGalleryImageHeight:setGalleryImageHeight
	  };
	})();


	var liberal_modal = (function() {
	 	var initialize = function() {
		 	$('a[data-toggle]').on('click', function(e){
		 		e.preventDefault();
		 	});
	  };
	  // Public API
	  return {
	    initialize: initialize
	  };
	})();

	var register_scroll_top_listeners = function() {

	 	$('a.scroll-top').on('click', function(e){
	 		e.preventDefault();
	 		$('html, body').animate({ scrollTop: 0}, 'slow');
	 	});

	};

	$(window).on('resize', function(){

		header_bar.setHeaderHeight();
		photo_gallery.setGalleryImageHeight();
		//header_bar.hideHamburgerMenuDisplay();
	});

	$( document ).ready(function() {
		header_bar.registerHeaderScrollDisplayListener();
		header_bar.registerHamburgerMenuDisplayListener();
		photo_gallery.initialize();
		liberal_modal.initialize();
		photo_gallery.setGalleryImageHeight();
		register_scroll_top_listeners();

		$(window).trigger('resize');
		$(window).trigger('scroll');
	});

} ( jQuery ) )
